import { Batch } from '../../../interfaces/Batch'
import { getExpiredStatusToday, ExpiredColorStatus } from '../../../utils/colors'

/**
 * Verifica si un lote está vencido o por vencer
 * @param batch - Lote a verificar
 * @param expirationDays - Días antes de vencimiento configurados para la marca
 * @returns true si está vencido o por vencer, false si está vigente
 */
export const isBatchExpiredOrExpiring = (
  batch: Batch | undefined,
  expirationDays: number = 0
): boolean => {
  if (!batch?.expirationDate) {
    return false  // Sin fecha de expiración, considerar vigente
  }

  const status = getExpiredStatusToday(batch.expirationDate, expirationDays)

  return (
    status === ExpiredColorStatus.expired ||      // Vencido
    status === ExpiredColorStatus.expireSoon      // Por vencer
  )
}
